import { FC } from "react"
import { ApplicationFormList } from "../../../module/applicationForm/containers/list"

export const ApplicationFormChange: FC = () => <ApplicationFormList />
